import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LoadingSpinnerComponent } from '@app/components/loading-spinner/loading-spinner.component';
import { AutocompleteTextFilterConfig } from '@app/models/filters/autocomplete-text-filter-config';
import { FilterStatus } from '@app/models/filters/filter-status';
import { GenericFilterConfig } from '@app/models/filters/generic-filter-config';
import accessibleAutocomplete from 'accessible-autocomplete';

@Component({
	selector: 'app-autocomplete-text',
	standalone: true,
	imports: [LoadingSpinnerComponent],
	templateUrl: './autocomplete-text.component.html',
	styleUrl: './autocomplete-text.component.css',
})
export class AutocompleteTextComponent {
	@Input() genericConfig: GenericFilterConfig = {} as GenericFilterConfig;

	specificConfig: AutocompleteTextFilterConfig = {} as AutocompleteTextFilterConfig;

	autocompleteValues: string[] = [];
	loading: boolean = false;

	@Output() autocompleted = new EventEmitter<FilterStatus>();

	@ViewChild('input') input!: ElementRef;

	constructor(private http: HttpClient) {}

	ngOnInit() {
		this.specificConfig = this.genericConfig as AutocompleteTextFilterConfig;
	}

	ngAfterViewInit() {
		// docs: https://alphagov.github.io/accessible-autocomplete/

		accessibleAutocomplete({
			element: document.querySelector(`#${this.specificConfig.id}autocomplete-container`),
			id: `${this.specificConfig.id}autocomplete`, // To match it to the existing <label>.
			source: this.serveAutocompleteValues,
			minLength: this.specificConfig.autocompleteThreshold,
			onConfirm: (confirmed: Object) => {
				if (confirmed !== undefined) {
					let stringValue = confirmed as string;
					if (stringValue !== undefined && stringValue !== '') {
						this.autocompleted.emit({
							filterId: this.specificConfig.id,
							selectedPrimaryValues: [stringValue],
							selectedSecondaryValues: [stringValue],
						});
					} else {
						this.autocompleted.emit({
							filterId: this.specificConfig.id,
							selectedPrimaryValues: [],
							selectedSecondaryValues: [],
						});
					}
				}
			},
		});
	}

	serveAutocompleteValues = (query: string, populateResults: Function) => {
		this.autocompleted.emit({
			filterId: this.specificConfig.id,
			selectedPrimaryValues: [],
			selectedSecondaryValues: [],
		});
		this.http.get<string[]>(this.specificConfig.source + query).subscribe((data) => populateResults(data));
	};
}
